import { Decimals } from '@/src/lib/SmartDB';
import { formatAmount } from '@/src/lib/SmartDB/Commons/formatters';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './NumberInput.module.scss';

interface NumberInputProps {
    className?: string;
    decimals?: Decimals;
    value?: bigint;
    setValue?: (value: bigint) => void;
    handleFocus?: () => void;
    handleBlur?: () => void;
    disabled?: boolean;
    isValid?: boolean;
    setIsValid?: (isValid: boolean) => void;
    min?: bigint;
    max?: bigint;
}

const MAX_INT_DIGITS = 15;

const NumberInput: React.FC<NumberInputProps> = (props: NumberInputProps) => {
    //--------------------------------------
    const { className, decimals, value, setValue, handleFocus, handleBlur, disabled, isValid: isValid_, setIsValid: setIsValid_, min: min_, max: max_ } = props;
    //--------------------------------------
    const max = useMemo(() => (max_ !== undefined ? max_ : BigInt(999_999_999 * Math.pow(10, decimals !== undefined ? decimals : 0))), [max_, decimals]);
    const min = useMemo(() => (min_ !== undefined ? (min_ > max ? 0n : min_) : 0n), [min_, max]);
    //--------------------------------------
    const [formattedText, setFormattedText] = useState<string>(getFormattedTextFromValue(value));
    const [isInternalUpdate, setIsInternalUpdate] = useState(false);
    //--------------------------------------
    const [isValid, setIsValid] = useState(isValid_ !== undefined ? isValid_ : true);
    //--------------------------------------
    useEffect(() => {
        if (isValid_ !== undefined) {
            setIsValid(isValid_);
        }
    }, [isValid_]);
    //--------------------------------------
    useEffect(() => {
        //----------------------
        if (isInternalUpdate === false) {
            const newFormattedText = getFormattedTextFromValue(value);
            // console.log(`useEffect ${name} isInternalUpdate ${isInternalUpdate} - value ${value} - formatedText ${formattedText} - newFormattedText ${newFormattedText}`);
            if (newFormattedText !== formattedText) {
                setFormattedText(newFormattedText);
            }
        } else {
            // console.log(`useEffect ${name} isInternalUpdate ${isInternalUpdate} - value ${value} - formatedText ${formattedText}`);
        }
        setIsInternalUpdate(false);
        //----------------------
        let isValid = value !== undefined && decimals !== undefined;
        //----------------------
        if (min !== undefined && value !== undefined && value < min) {
            isValid = false;
        }
        if (max !== undefined && value !== undefined && value > max) {
            isValid = false;
        }
        //----------------------
        if (setIsValid_ !== undefined) {
            setIsValid_(isValid);
        } else {
            setIsValid(isValid);
        }
        //----------------------
    }, [value, min, max]);
    //--------------------------------------
    function getFormattedTextFromValue(value: bigint | undefined) {
        //TODO: controlar esto, no se donde se usa
        // alert('getFormattedTextFromValue');
        const newFormattedText = formatAmount(value, decimals,  decimals, 2);
        return newFormattedText;
    }
    function getValueFromFormattedText(formatedText: string) {
        formatedText = formatedText.replace(/,/g, '');
        const numberValue = parseFloat(formatedText);
        if (!isNaN(numberValue) && decimals !== undefined) {
            const pot = Math.pow(10, decimals);
            const newValue = BigInt(Math.floor(numberValue * pot));
            // if (newValue !== value) {
            return newValue;
            // }
        } else {
            // if (0n !== value) {
            return 0n;
            // }
        }
        // return formattedValue;
    }
    function setValueAndFormattedText(newValue: bigint) {
        setValue?.(newValue);
        const newFormattedText = getFormattedTextFromValue(newValue);
        if (newFormattedText !== formattedText) setIsInternalUpdate(true);
        setFormattedText(newFormattedText);
        console.log(`setValueAndFormattedText ${name} isInternalUpdate ${isInternalUpdate} - value ${newValue} - formatedText ${newFormattedText}`);
    }
    function setFormattedTextAndValue(newFormattedText: string) {
        setFormattedText(newFormattedText);
        const newValue = getValueFromFormattedText(newFormattedText);
        if (newValue !== value) setIsInternalUpdate(true);
        setValue?.(newValue);
        console.log(`setValueAndFormattedText ${name} isInternalUpdate ${isInternalUpdate} - value ${newValue} - formatedText ${newFormattedText}`);
    }
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (decimals === undefined || value === undefined) {
            return;
        }
        if (e.key === '+' || e.key === '-' || e.key === 'e') {
            e.preventDefault();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const pot = Math.pow(10, decimals);
            const newValue = value + BigInt(pot);
            // console.log(`handleKeyDown ${name}  value ${value} - formatedText ${formattedText}`);
            setValueAndFormattedText(newValue);
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const pot = Math.pow(10, decimals);
            const newValue = value > BigInt(pot) ? value - BigInt(pot) : 0n;
            // console.log(`handleKeyDown ${name}  value ${value} - formatedText ${formattedText}`);
            setValueAndFormattedText(newValue);
        }
    };
    const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
        //TODO: volver activar esto cuando logremos detener el scroll
        // if (decimals === undefined  || value === undefined) {) {
        //     return;
        // }
        // ademas tamb sucede de estar haciendo scroll en la pagina y que se modifiquen los valores sin querer
        // // Prevent window from scrolling
        // const preventScroll = (event: WheelEvent) => {
        //     event.preventDefault();
        // };
        // window.addEventListener("wheel", preventScroll, { passive: false });
        // const pot = Math.pow(10, decimals);
        // let newValue = value;
        // if (e.deltaY < 0) {
        //     newValue += BigInt(100 * pot);
        // } else if (e.deltaY > 0) {
        //     newValue = newValue > BigInt(100 * pot) ? newValue - BigInt(100 * pot) : 0n;
        // }
        // setValue(newValue);
        // // Restore normal scrolling behavior
        // window.removeEventListener("wheel", preventScroll);
        // e.preventDefault();
        // e.stopPropagation();
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        //-------------------------------------
        if (decimals === undefined || value === undefined) {
            return;
        }
        //-------------------------------------
        const inputElement = e.target;
        let inputText: string = inputElement.value;
        //-------------------------------------
        // console.log(`handleChange ${name} ${inputText}`);
        let cursorPosition = inputElement.selectionStart || undefined;
        let digitsBeforeCursor = inputText.substring(0, cursorPosition).replace(/[^0-9]/g, '').length;
        //-------------------------------------
        // let digits = inputText.replace(/[^0-9]/g, '').length;
        // let intDigits = inputText.replace(/[^0-9]/g, '').split('.')[0].length;
        // let decimalsDigits = 0;
        // if (inputText.indexOf('.') > 0) {
        //     decimalsDigits = inputText.replace(/[^0-9]/g, '').split('.')[1].length;
        // }
        //-------------------------------------
        if (inputText.length === 0) {
            setFormattedTextAndValue('');
            return;
        }
        //-------------------------------------
        // Remove non-numeric and non-dot characters
        let sanitizedInput: string = inputText.replace(/[^0-9.]/g, '');
        // Remove leading zeros
        sanitizedInput = sanitizedInput.replace(/^00+/, '0');
        sanitizedInput = sanitizedInput.replace(/^0([1-9])/, '$1');

        if (decimals === 0) {
            // Remove dot if decimals is 0
            sanitizedInput = sanitizedInput.replace(/\./g, '');
        }

        // Add leading zero if starts with dot
        if (sanitizedInput.startsWith('.')) {
            sanitizedInput = '0' + sanitizedInput;
        }
        // Remove extra dots
        // remove extra decimals
        let dotCount = 0;
        let decimalstCount = 0;
        sanitizedInput = sanitizedInput
            .split('')
            .filter((char) => {
                if (char === '.') {
                    dotCount += 1;
                    return dotCount <= 1;
                } else {
                    if (dotCount > 0) {
                        if (decimalstCount + 1 > decimals) {
                            return false;
                        } else {
                            decimalstCount++;
                        }
                    }
                }
                return true;
            })
            .join('');
        //-------------------------------------
        // Check if number is not NaN and less than or equal to MAX_INT_DIGITS
        let numberCheck = parseFloat(sanitizedInput);
        if (isNaN(numberCheck)) {
            //-------------------------------------
            // no es un numero valido
            //-------------------------------------
            // Update cursor position
            if (inputElement === document.activeElement) {
                requestAnimationFrame(() => {
                    if (cursorPosition !== undefined) {
                        inputElement.setSelectionRange(cursorPosition, cursorPosition);
                    }
                });
            }
        } else {
            // elimino mas caracteres enteros de mas
            let dotCount = 0;
            let intCount = 0;
            sanitizedInput = sanitizedInput
                .split('')
                .filter((char) => {
                    if (char === '.') {
                        dotCount += 1;
                    } else if (dotCount === 0) {
                        if (intCount + 1 > MAX_INT_DIGITS) {
                            // supere el maximo permitido
                            return false;
                        } else {
                            intCount++;
                        }
                    }
                    return true;
                })
                .join('');
            //-------------------------------------
            numberCheck = parseFloat(sanitizedInput);
            // const pot = Math.pow(10, decimals);
            //-------------------------------------
            // let formattedValue = formatAmount(BigInt(Math.floor(numberCheck * pot)), decimals);
            let formattedValue = formatAmount(numberCheck, decimals);
            //-------------------------------------
            if (sanitizedInput.endsWith('.')) {
                formattedValue = formattedValue + '.';
            }
            //-------------------------------------
            let decimalsDigitsAfter = 0;
            if (formattedValue.indexOf('.') > 0) {
                decimalsDigitsAfter = formattedValue.split('.')[1].length;
            }
            //-------------------------------------
            if (decimalstCount > decimalsDigitsAfter) {
                // tengo que agregar ceros a la derecha
                // reviso so hay punto
                if (formattedValue.indexOf('.') > 0) {
                    formattedValue = formattedValue + '0'.repeat(decimalstCount - decimalsDigitsAfter);
                } else {
                    formattedValue = formattedValue + '.' + '0'.repeat(decimalstCount - decimalsDigitsAfter);
                }
            }
            //-------------------------------------
            setFormattedTextAndValue(formattedValue);
            //-------------------------------------
            // Update cursor position
            if (inputElement === document.activeElement) {
                //&& formattedValue.length != input.length
                //     const newCursorPosition =
                //         sanitizedInput
                //             .substring(0, sanitizedInput.length)
                //             .replace(/[^0-9]/g, '')
                //             .indexOf(sanitizedInput.substring(0, cursorPosition).replace(/[^0-9]/g, '')) + digitsBeforeCursor;

                requestAnimationFrame(() => {
                    if (cursorPosition !== undefined) {
                        // let countDigitsBeforePosition = sanitizedInput.substring(0, cursorPosition).replace(/[^0-9]/g, '').length;
                        // let newCursorPosition = sanitizedInput.replace(/[^0-9]/g, '').indexOf(sanitizedInput.substring(0, cursorPosition).replace(/[^0-9]/g, ''))

                        // let countCommasBeforePosition = 0;
                        // for (let i = 0; i < cursorPosition; i++) {
                        //     if (inputText.substring(i, i + 1) === ',') {
                        //         countCommasBeforePosition++;
                        //     }
                        // }

                        // let countNumbersResult = formattedValue.replace(/[^0-9]/g, '').length;
                        // let diffPosition = 0;
                        // // if (digits !== countNumbersResult) {
                        // //     diffPosition += countNumbersResult - digits;
                        // // }

                        let countDigitsAfterFormat = 0;
                        let newCursorPosition = undefined;
                        for (let i = 0; i < formattedValue.length; i++) {
                            if (formattedValue.charAt(i).match(/[0-9]/g)) {
                                if (countDigitsAfterFormat >= digitsBeforeCursor) {
                                    newCursorPosition = i;
                                    break;
                                } else {
                                    countDigitsAfterFormat++;
                                }
                            }
                        }

                        if (newCursorPosition !== undefined) {
                            inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
                        }
                        // if (digits === countNumbersResult) {
                        //     inputElement.setSelectionRange(cursorPosition, cursorPosition);
                        // } else if (digits > countNumbersResult) {
                        //     // borro un digito
                        //     inputElement.setSelectionRange(cursorPosition - (countNumbersResult - digits), cursorPosition - (countNumbersResult - digits));
                        // } else if (digits < countNumbersResult) {
                        //     // agrego un digito
                        //     inputElement.setSelectionRange(cursorPosition + (countNumbersResult - digits), cursorPosition + (countNumbersResult - digits));
                        // }

                        // let digitsBeforeCursor = inputElement.value.substring(0, cursorPosition).replace(/[^0-9]/g, '').length +1;
                        // inputElement.setSelectionRange(cursorPosition, cursorPosition);
                    }
                });
            }
        }
    };
    //--------------------------------------

    return (
        <>
            <input
                type="text"
                className={className !== undefined ? className : `${styles.input} ${isValid === false ? styles.error : ''}`}
                value={formattedText}
                disabled={decimals === undefined || value === undefined || (disabled !== undefined ? disabled : false)}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onWheel={handleWheel}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
            {/* <p>Real Number: {value.toString()}</p>  */}
            {/* <p>Updating: {isInternalUpdate.toString()}</p> */}
        </>
    );
};

export default NumberInput;
